var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSolidChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55808 7.55806C9.80215 7.31398 10.1979 7.31398 10.442 7.55806L13.442 10.5581C13.6207 10.7368 13.6742 11.0056 13.5774 11.2392C13.4807 11.4727 13.2528 11.625 13 11.625H7.00002C6.74723 11.625 6.51933 11.4727 6.42259 11.2392C6.32586 11.0056 6.37933 10.7368 6.55808 10.5581L9.55808 7.55806Z",
    fill: "white",
    fillOpacity: 0.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSolidChevronUp);
export default __webpack_public_path__ + "static/media/arrow-solid-chevron-up.ae206a94240f2cf9a4c2165a6dbede29.svg";
export { ForwardRef as ReactComponent };